<template>
  <div class="liBaiDetail">
    <!-- Loading 状态 -->
    <div v-if="isLoading" class="loading">
      正在加载中...
    </div>

    <!-- 卡券模块 -->
    <div class="container" v-show="!isLoading && detail.orderNo">
      <div class="goodBox">
        <img :src="detail.gcCoverUrl" />
        <div class="rg">
          <h2>{{ detail.goodsName }}</h2>
          <p>使用条件：无使用门槛</p>
          <p>有效期：{{ detail.expireTime }}</p>
        </div>
      </div>
      <!-- 权益状态 0：待领取 1：已领取 2：领取失败 3：领取中 -->
      <h2 class="codeTitle" v-show="detail.orderStatus === 1">券码信息</h2>
      <div
        class="codeBox"
        v-show="detail.orderStatus === 1"
        v-for="(item, ind) in detail.codeList"
        :key="ind"
      >
        <!-- 卡号 -->
        <div class="codeItem" v-show="item.cardNo">
          <div class="code">
            卡号：<span>{{ item.cardNo }}</span>
          </div>
          <div class="copy" v-clipboard:copy="item.cardNo" @click="copySuccess">
            复制
          </div>
        </div>

        <!-- 卡密 -->
        <div class="codeItem" v-show="item.cardPwd">
          <div class="code">
            卡密：<span>{{ item.cardPwd }}</span>
          </div>
          <div
            class="copy"
            v-clipboard:copy="item.cardPwd"
            @click="copySuccess"
          >
            复制
          </div>
        </div>

        <!-- 短链 -->
        <div class="codeItem" v-show="item.shortUrl">
          <div class="code">短链：{{ item.shortUrl }}</div>
          <div
            class="copy"
            v-clipboard:copy="item.shortUrl"
            @click="copySuccess"
          >
            复制
          </div>
        </div>

        <!-- 验证码 -->
        <div class="codeItem" v-show="item.verifyCode">
          <div class="code">验证码：{{ item.verifyCode }}</div>
          <div
            class="copy"
            v-clipboard:copy="item.verifyCode"
            @click="copySuccess"
          >
            复制
          </div>
        </div>

        <!-- 兑换码 -->
        <div class="codeItem" v-show="item.redeemCode">
          <div class="code">兑换码：{{ item.redeemCode }}</div>
          <div
            class="copy"
            v-clipboard:copy="item.redeemCode"
            @click="copySuccess"
          >
            复制
          </div>
        </div>
      </div>
    </div>

    <!-- 使用说明 -->
    <div class="container ruleBox" v-show="!isLoading && detail.orderNo">
      <h3>·使用说明·</h3>
      <div v-html="detail.gcText" class="ruleHtml"></div>
    </div>
  </div>
</template>

<script>
import { liBaiReceiveOrder } from '@/api/liBai'
export default {
  data() {
    return {
      detail: {},
      isLoading: true,
      pollingCount: 0, // 轮询次数计数器
      maxPollingCount: 10
    }
  },
  mounted() {
    this.startPolling()
  },
  methods: {
    startPolling() {
      this.isLoading = true
      this.pollingTimer = setInterval(async () => {
        await this.loadDetail()

        // 增加轮询次数
        this.pollingCount++

        // 判断是否满足终止条件
        if (
          this.detail.orderStatus === 1 ||
          this.pollingCount >= this.maxPollingCount
        ) {
          this.stopPolling()
        }
      }, 1000) // 每1秒执行一次
    },
    stopPolling() {
      clearInterval(this.pollingTimer)
      this.isLoading = false // 隐藏 loading
    },
    async loadDetail() {
      try {
        const { code, data } = await liBaiReceiveOrder()
        if (data.codeList && data.codeList.length > 0) {
          data.expireTime = data.codeList[0].expireTime
        }
        this.detail = data

        if (code === 403) {
          sessionStorage.removeItem('liBaiToken')
        }
      } catch (error) {
        sessionStorage.removeItem('liBaiToken')
        console.log(error)
      }
    },
    copySuccess() {
      this.$toast({ message: '复制成功!' })
    },
    copyError() {
      this.$toast({ message: '复制失败!' })
    }
  }
}
</script>

<style lang="less" scoped>
.liBaiDetail {
  min-height: 100vh;
  background: #daf2ff;
  padding: 18px 15px;
  box-sizing: border-box;
  .loading {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 16px;
    color: #000;
  }
  .container {
    background: #ffffff;
    border-radius: 15px;
    padding: 15px;
    box-sizing: border-box;
    .goodBox {
      display: flex;
      align-items: center;
      padding-bottom: 13px;
      border-bottom: solid 1px #eeeff3;
      box-sizing: border-box;
      img {
        width: 109px;
        height: 70px;
        display: block;
        border-radius: 10px;
      }
      .rg {
        margin-left: 10px;
        color: #999999;
        font-size: 12px;
        min-width: 0;
        flex: 1;
        height: 60px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        h2 {
          font-size: 15px;
          color: #010101;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
    .codeTitle {
      font-size: 16px;
      font-weight: 600;
      padding: 19px 0 28px;
    }
    .codeBox {
      .codeItem {
        display: flex;
        font-size: 12px;
        align-items: center;
        color: #666;
        margin-bottom: 10px;
        .code {
          flex: 1;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          span {
            color: #000000;
          }
        }
        .copy {
          display: inline-block;
          width: 50px;
          line-height: 24px;
          border-radius: 12px;
          border: 1px solid #0087dc;
          font-size: 12px;
          color: #0087dc;
          text-align: center;
          margin-left: 6px;
          cursor: pointer;
        }
      }
    }
  }
  .ruleBox {
    color: #666;
    font-size: 12px;
    margin-top: 16px;
    h3 {
      font-size: 18px;
      padding: 5px 0 18px;
      color: #000000;
      font-weight: normal;
      text-align: center;
    }
    .ruleHtml {
      /deep/ img {
        display: block;
        width: 100% !important;
        height: auto !important;
      }
    }
  }
}
</style>
